import {
  Feather,
  Palette,
  Scissors,
  Sparkles,
  Flower2,
  Hand,
  Crown,
  Waves,
} from "lucide-react";

export const SERVICE_CATEGORIES = [
  {
    id: "threading",
    name: "Threading",
    icon: Feather,
    blurb: "Precision shaping for a clean, flawless finish.",
    items: ["Threading", "Chin", "Upperlip"],
  },
  {
    id: "hair-color",
    name: "Hair Color",
    icon: Palette,
    blurb: "Rich, dimensional colour tailored to your style.",
    items: [
      "Color (Ammonia)",
      "Color (Ammonia Free)",
      "Color (Own Color)",
      "Color (Crown)",
      "Color Full",
      "Highlight (Per Strip)",
    ],
  },
  {
    id: "hair-treatments-styling",
    name: "Hair Treatments & Styling",
    icon: Scissors,
    blurb: "Nourishing treatments and artistry for every length.",
    items: [
      "Henna",
      "Hot Oil",
      "Dandruff Treatment",
      "Hair Spa (Normal)",
      "Hair Spa (Argan)",
      "Hair Treatment (Shoulder Length)",
      "Hair Treatment (Crown)",
      "Hair Wash",
      "Blowdry Straight (Shoulder)",
      "Blowdry Curl",
      "Ironing",
      "Hair Cut Baby",
      "Hair Trim",
      "Hair Cut U/V",
      "Hair Cut Straight",
      "Hair Cut Layer/Step",
      "Hair Cut Layer Long",
    ],
  },
  {
    id: "waxing",
    name: "Waxing",
    icon: Sparkles,
    blurb: "Silky-smooth skin, gently and hygienically done.",
    items: [
      "Bikini Wax",
      "Full Leg Wax",
      "Half Leg Wax",
      "Full Hand Wax",
      "Half Hand Wax",
      "Under Arm Wax",
      "Back Wax",
      "Stomach Wax",
      "Full Body Wax",
      "Fruit Wax (add-on to any wax)",
    ],
  },
  {
    id: "facials-bleach",
    name: "Facials & Bleach",
    icon: Flower2,
    blurb: "Glow-restoring care for every skin mood.",
    items: [
      "Gold Facial",
      "Diamond Facial",
      "Normal Facial",
      "Flower Facial",
      "Pearl Facial",
      "Veg Peel",
      "Clean Up",
      "Aroma Facial",
      "Whitening",
      "Tan Removal Facial",
      "Fruit Bleach",
      "Deetan",
      "Lacto Bleach",
    ],
  },
  {
    id: "nails-hands",
    name: "Nails & Hands",
    icon: Hand,
    blurb: "Immaculate hands, polished to perfection.",
    items: ["Nail Gel", "Pedicure", "Manicure", "Nail Color / File"],
  },
  {
    id: "makeup-bridal",
    name: "Makeup & Bridal",
    icon: Crown,
    blurb: "Radiance for your biggest moments.",
    items: [
      "Bridal Make Up (Full Package)",
      "Party Make Up",
      "Hair Style",
      "Saree",
      "Henna Design (Hand / Leg)",
    ],
  },
  {
    id: "massage-body",
    name: "Massage & Body Treatments",
    icon: Waves,
    blurb: "Deep calm and renewal, from head to toe.",
    items: ["Leg Massage", "Back Massage"],
  },
];
